// extracted by mini-css-extract-plugin
export default {"logo":"y6","cancel":"z6","stickyheader":"A6","buttonswrap":"B6","item":"C6","starterKit":"E6","boldHeader":"F6","reviewheader":"G6","text":"H6","username":"I6"};
    if(module.hot) {
      // 1715188240202
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  